import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiservicefrompunetoshirdi() {



  const cardData =
  {
    keyword: 'Taxi Services from Pune to Shirdi',
    heading: 'Aaryan Travels: Taxi Services from Pune to Shirdi',
    headingDescription: ' Aaryan Travels offers reliable Taxi Services from Pune to Shirdi, making your pilgrimage journey to the sacred Sai Baba Temple comfortable and hassle-free. Whether you’re traveling with family, senior citizens, or in a group, our fleet of sedans, SUVs, and tempo travellers ensures a smooth ride with experienced chauffeurs who are well-versed with the route. We provide doorstep pickup from any location in Pune—be it Katraj, Hinjewadi, Wagholi, Hadapsar, or Pune Airport—along with flexible one-way or round-trip options. With transparent fares, clean vehicles, and 24/7 availability, Aaryan Travels guarantees a peaceful and convenient travel experience from Pune to Shirdi.',

    top: 'Top Places to Visit in Shirdi with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "The Shirdi Sai Baba Temple is the main pilgrimage site dedicated to the revered saint Sai Baba, attracting millions of devotees annually. The temple complex includes the Samadhi Mandir where Sai Baba’s mortal remains are preserved. Aarti ceremonies held four times a day create a deeply spiritual atmosphere. Devotees stand in long queues with utmost devotion and faith. The temple is the heart and soul of Shirdi’s divine aura."
  },
  {
    "title": "Dwarkamai Masjid",
    "description": "Dwarkamai Masjid is where Sai Baba spent a major part of his life, offering solace and guidance to his followers. The sacred dhuni (fire) that Baba lit is still kept burning and its ashes are believed to have healing powers. The simple stone structure radiates peace and humility. People sit quietly, absorbing the spiritual energy. Dwarkamai is Shirdi’s symbol of compassion and unity."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan, meaning ‘Seat of the Guru’, is the place where Sai Baba was first seen as a young ascetic, sitting under a neem tree. A shrine with a sacred idol and incense burners now marks this holy location. Devotees believe lighting incense sticks here fulfills wishes. The surrounding neem leaves are considered prasad. Gurusthan is Shirdi’s earliest mark of Sai Baba’s presence."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the place where Sai Baba rested on alternate nights during his later years. Today, it holds a ceremonial significance as the Palanquin Procession (Palkhi) of Sai Baba’s idol starts from Dwarkamai and reaches here every Thursday. The interior houses Baba’s bedding, wooden seat, and photographs. Chavadi keeps alive the rituals practiced during his lifetime. It is Shirdi’s sacred heritage corner."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description": "Located around 70 km from Shirdi, Shani Shingnapur Temple is dedicated to Lord Shani (Saturn). The unique feature of this village is that no home has doors or locks, as people believe Lord Shani protects them from theft and harm. The open-air shrine with a large black stone idol attracts devotees seeking relief from obstacles and misfortune. Shani Shingnapur is Shirdi’s powerful spiritual excursion."
  },
  {
    "title": "Sai Heritage Village and Theme Park",
    "description": "Sai Heritage Village is a creative theme park that depicts various scenes from Sai Baba’s life through life-sized statues and artistic installations. Kids enjoy ropeways, rides, and adventure zones, while elders appreciate the devotional atmosphere. The rural setting adds authenticity to the storytelling. It blends spirituality with recreation. Sai Heritage Village is Shirdi’s engaging family attraction."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden where Sai Baba used to water plants and spend quiet moments in meditation. A lamp lit by Baba still burns inside a small shrine called Nanda Deep. The refreshing greenery and flower beds create a calming environment. Visitors walk through the peaceful pathways reflecting on Baba’s humble lifestyle. Lendi Baug is Shirdi’s tranquil spiritual garden."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is believed to be the place where Sai Baba first entered Shirdi and was welcomed by a local priest named Mhalsapati with the words ‘Aao Sai’. Dedicated to Lord Khandoba, a form of Shiva, the temple holds immense historical importance. Pilgrims visit to honor the moment Baba was first recognized as a saint. Khandoba Temple is Shirdi’s welcoming point of divine arrival."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers a refreshing break from the spiritual tour with thrilling water rides, wave pools, and rain dance setups. Families and children enjoy a full day of fun and excitement. Clean facilities and multiple food courts make it comfortable for all age groups. It provides entertainment amid devotion. Wet N Joy is Shirdi’s joyful recreational escape."
  },
  {
    "title": "Prasadalaya",
    "description": "Prasadalaya is the massive dining hall run by the Shirdi Sansthan, where thousands of devotees are served free or low-cost meals daily. The system is highly organized, offering simple yet wholesome meals prepared with utmost hygiene. Eating together with people from all walks of life symbolizes unity and equality. Prasadalaya is Shirdi’s embodiment of community service."
  }
],


"services": [
  {
    "name": "Taxi Services from Pune to Shirdi",
    "description": "Experience convenient and reliable Taxi Services from Pune to Shirdi, designed to offer you a stress-free journey to the spiritual town of Shirdi. Our service guarantees timely pickups, clean and comfortable vehicles, and professional drivers who prioritize your safety and comfort. Perfect for devotees, tourists, and business travelers, this service ensures a smooth ride with flexible scheduling options."
  },
  {
    "name": "Pune Shirdi Cab",
    "description": "Our Pune Shirdi Cab service provides comfortable and affordable transportation for individuals and groups traveling between Pune and Shirdi. With a fleet ranging from compact cars to spacious SUVs, travelers can choose the best vehicle according to their needs. Enjoy courteous drivers, on-time service, and transparent pricing for a hassle-free journey to this revered destination."
  },
  {
    "name": "Outstation Taxi Pune to Shirdi",
    "description": "Opt for our Outstation Taxi service from Pune to Shirdi for a safe and comfortable long-distance travel experience. Our outstation taxis are well-maintained, air-conditioned, and driven by experienced chauffeurs who are familiar with the best routes. Whether you're traveling for pilgrimage or leisure, this service offers flexible packages, including one-way and round-trip options."
  },
  {
    "name": "Cab Hire Pune Shirdi",
    "description": "Hire cabs from Pune to Shirdi with ease and confidence through our reliable Cab Hire service. Offering various vehicle types including sedans, SUVs, and luxury cars, this service caters to diverse travel requirements. Our drivers are professional, punctual, and committed to providing a pleasant journey with comfortable seating and smooth rides."
  },
  {
    "name": "Pune to Shirdi Chauffeur Cab",
    "description": "Travel in style and comfort with our Pune to Shirdi Chauffeur Cab service. Enjoy the luxury of a dedicated driver who ensures timely pickups and drop-offs while you relax during the journey. Ideal for business travelers and families, this service combines professionalism with personalized care to make your trip enjoyable and hassle-free."
  },
  {
    "name": "One Way Cab Pune Shirdi",
    "description": "Book a convenient One Way Cab from Pune to Shirdi for quick and affordable travel. Perfect for short trips, this service offers flexible pickup points, well-maintained vehicles, and courteous drivers. Whether it’s a spiritual visit or a leisure trip, our one-way cabs provide an efficient and cost-effective solution."
  },
  {
    "name": "Pune to Shirdi Taxi Booking",
    "description": "Easily book your Pune to Shirdi taxi through our seamless online and offline booking system. Get instant confirmations, transparent fare estimates, and flexible scheduling options. Our dedicated support team ensures your booking process is smooth and hassle-free, so you can focus on your journey ahead."
  },
  {
    "name": "Affordable Cab Pune Shirdi",
    "description": "Travel affordably without compromising on quality with our budget-friendly Pune to Shirdi cab service. Enjoy clean, reliable vehicles and professional drivers at competitive prices. Ideal for solo travelers, families, and groups seeking economical transportation for their pilgrimage or trip."
  },
  {
    "name": "Pune Shirdi Sedan Hire",
    "description": "Choose our Sedan Hire service for a comfortable and stylish ride from Pune to Shirdi. Our sedans are well-equipped with air conditioning, spacious interiors, and driven by experienced chauffeurs. This service is perfect for small groups and business travelers who prioritize comfort and reliability."
  },
  {
    "name": "Best Cab Pune to Shirdi",
    "description": "Experience the Best Cab service from Pune to Shirdi with premium vehicles, exceptional customer support, and punctual pickups. We focus on providing a superior travel experience with transparent pricing, professional drivers, and timely service, ensuring your journey is safe and comfortable."
  },
  {
    "name": "Pune Shirdi Tour Cab",
    "description": "Enhance your pilgrimage or sightseeing trip with our Pune Shirdi Tour Cab service. Our knowledgeable drivers can assist you with local insights and recommended stops along the way. Customize your tour itinerary and enjoy a relaxed, comfortable journey with hassle-free transportation."
  },
  {
    "name": "Cab for Shirdi from Pune",
    "description": "Book a dedicated Cab for Shirdi from Pune for your spiritual or leisure travel needs. We offer a variety of vehicles to suit individual and group travel, ensuring clean, well-maintained cars and professional drivers. Reliable service and flexible packages make your planning easy and efficient."
  },
  {
    "name": "Online Booking Pune to Shirdi Cab",
    "description": "Take advantage of our easy Online Booking platform to reserve your Pune to Shirdi cab instantly. Enjoy secure payments, instant booking confirmation, and the ability to schedule rides according to your convenience. Our user-friendly system makes cab booking fast and straightforward."
  },
  {
    "name": "AC Taxi Pune Shirdi",
    "description": "Stay cool and comfortable during your journey with our AC Taxi service from Pune to Shirdi. Our air-conditioned vehicles are regularly sanitized and maintained to provide a pleasant environment, perfect for summer travel or long rides. Professional drivers ensure a safe and smooth trip."
  },
  {
    "name": "Round Trip Cab Pune to Shirdi",
    "description": "Plan your complete journey with our Round Trip Cab service from Pune to Shirdi, including return travel at competitive rates. Enjoy the convenience of a single booking for both legs of your trip, with assured vehicle availability and professional chauffeurs committed to timely pickups and comfortable rides."
  }
],
"tableData": [
  ["Taxi Services from Pune to Shirdi", "Pune Shirdi Cab"],
  ["Outstation Taxi Pune to Shirdi", "Cab Hire Pune Shirdi"],
  ["Pune to Shirdi Chauffeur Cab", "One Way Cab Pune Shirdi"],
  ["Pune to Shirdi Taxi Booking", "Affordable Cab Pune Shirdi"],
  ["Pune Shirdi Sedan Hire", "Best Cab Pune to Shirdi"],
  ["Pune Shirdi Tour Cab", "Cab for Shirdi from Pune"],
  ["Online Booking Pune to Shirdi Cab", "AC Taxi Pune Shirdi"],
  ["Round Trip Cab Pune to Shirdi", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Taxi Services from Pune to Shirdi",
    "WhyChoosedescription": "Aaryan Travels offers comfortable and timely taxi services for your journey from Pune to the sacred town of Shirdi."
  },
  {
    "WhyChooseheading": "Convenient Pickup from Anywhere in Pune",
    "WhyChoosedescription": "Our drivers are ready to pick you up from your preferred location in Pune for a hassle-free start to your trip."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for a Pleasant Journey",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned taxis designed for your comfort and safety throughout the trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Shirdi Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes to get you to Shirdi quickly and safely."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trips",
    "WhyChoosedescription": "Choose from one-way rides or round trips based on your travel plans to Shirdi."
  },
  {
    "WhyChooseheading": "Variety of Vehicle Options to Suit Your Needs",
    "WhyChoosedescription": "Select from sedans, SUVs, or tempo travellers depending on your group size and luggage."
  }
]




























  }

const faqData = [
  {
    question: 'Does Aaryan Travels provide taxi services from Pune to Shirdi?',
    answer: 'Yes, Aaryan Travels offers reliable and comfortable taxi services for travel from Pune to Shirdi.',
  },
  {
    question: 'How can I book a taxi from Pune to Shirdi with Aaryan Travels?',
    answer: 'You can easily book your taxi via our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for Pune to Shirdi taxi services?',
    answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel preferences.',
  },
  {
    question: 'Are taxi services available for one-way and round trips between Pune and Shirdi?',
    answer: 'Yes, Aaryan Travels provides both one-way and round-trip taxi services from Pune to Shirdi.',
  },
  {
    question: 'Are the drivers experienced with the Pune to Shirdi route?',
    answer: 'Absolutely. Our drivers are professional, licensed, and familiar with the Pune-Shirdi route to ensure a safe journey.',
  },
  {
    question: 'Can I book hourly or full-day packages for Pune to Shirdi taxi travel?',
    answer: 'Yes, we offer flexible hourly and full-day packages to accommodate your travel needs.',
  },
  {
    question: 'What safety and hygiene measures does Aaryan Travels follow for Pune to Shirdi taxi services?',
    answer: 'All vehicles are sanitized regularly, and our drivers adhere to strict safety protocols for passenger well-being.',
  },
  {
    question: 'Is Aaryan Travels taxi service from Pune to Shirdi available 24x7?',
    answer: 'Yes, our taxi services operate round the clock for Pune to Shirdi travel.',
  },
  {
    question: 'What payment options are accepted for Pune to Shirdi taxi bookings?',
    answer: 'We accept cash, credit/debit cards, UPI, and popular digital wallets for convenient payment.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for Pune to Shirdi taxi services?',
    answer: 'Yes, Aaryan Travels allows you to specify your preferred pickup and drop-off points within Pune and Shirdi.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Kulkarni',
    feedback: 'Aaryan Travels provided a smooth and comfortable taxi ride from Pune to Shirdi. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Aarti Deshpande',
    feedback: 'Excellent service and friendly driver for our Pune to Shirdi trip with Aaryan Travels.',
    rating: 5,
  },
];

















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Services from Pune to Shirdi",
  "image": "https://aaryantravels.com/assets/images/pune-shirdi-cab.jpg", // replace with actual image URL
  "description": "Affordable and reliable taxi services from Pune to Shirdi. Book AC sedans, SUVs, and chauffeur-driven cabs for one-way or round trips. Online booking available for comfortable and safe travel with Aaryan Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update as needed
    "ratingCount": "4100", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/taxi-services-pune-shirdi"
  }
};







  return (
    <div>

<Helmet>
  <title>Taxi Services from Pune to Shirdi | Affordable & Reliable Cab | Aaryan Travels</title>
  <meta
    name="description"
    content="Affordable and reliable taxi services from Pune to Shirdi. Book AC sedans, SUVs, and chauffeur-driven cabs for one-way or round trips. Online booking available for comfortable and safe travel with Aaryan Travels."
  />
  <meta
    name="keywords"
    content="Taxi Services from Pune to Shirdi, Pune Shirdi Cab, Outstation Taxi Pune to Shirdi, Cab Hire Pune Shirdi, Pune to Shirdi Chauffeur Cab, One Way Cab Pune Shirdi, Pune to Shirdi Taxi Booking, Affordable Cab Pune Shirdi, Pune Shirdi Sedan Hire, Best Cab Pune to Shirdi, Pune Shirdi Tour Cab, Cab for Shirdi from Pune, Online Booking Pune to Shirdi Cab, AC Taxi Pune Shirdi, Round Trip Cab Pune to Shirdi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxiservicefrompunetoshirdi;